import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 200]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);
  return <section id="home" className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-85">
      {/* Parallax Background */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0" data-id="element-86">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2832&auto=format&fit=crop")',
        filter: 'brightness(0.85)'
      }} data-id="element-87" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" data-id="element-88" />
      </motion.div>

      {/* Content */}
      <motion.div style={{
      opacity
    }} className="relative z-10 text-center px-4 max-w-4xl mx-auto" data-id="element-89">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="block text-white/90 text-sm md:text-base tracking-[0.3em] uppercase mb-6" data-id="element-90">
          Photographer Based in the Shenandoah Valley
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-8 leading-tight" data-id="element-91">
          Capturing Moments
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-white/80 font-light text-lg md:text-xl max-w-2xl mx-auto italic font-serif" data-id="element-92">
          Timeless photography for the wild at heart
        </motion.p>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div style={{
      opacity
    }} animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10 text-white/70" data-id="element-93">
        <ChevronDown className="w-8 h-8" data-id="element-94" />
      </motion.div>
    </section>;
}